import { api } from ".";

export function getAllRoles(){
    return api.get('/roles')
}